import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { WorkOrder } from '../WorkOrder'
import type { IAction } from '../../action/IAction'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class CreateWorkOrderWithTasksArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  workOrder: WorkOrder
}

export interface ICreateWorkOrderWithTasks extends IAction<WorkOrder, CreateWorkOrderWithTasksArgs> {}
